import { withRoleAccess } from '@app/routes';
import type { IIPWhitelistTableColumns } from '@entities/merchant/ip';
import { useIPWhitelist } from '@entities/merchant/ip';
import ModalOpenBtn from '@features/modal-open-btn';
import ErrorMessage from '@shared/components/ErrorMessage';
import Loading from '@shared/components/Loading';
import LoadingSpinner from '@shared/components/LoadingSpinner';
import { Pagination, PaginationRows } from '@shared/components/Pagination';
import {
  Table,
  THead,
  TBody,
  TableActions,
  TableActionsItem,
  TableContainer,
  TableProvider,
} from '@shared/components/Table';

import { useTableSettings } from './settings/useTableSettings';

const SettingsIPWhitelistWidget = () => {
  const {
    ipWhitelist,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,

    filter,
  } = useIPWhitelist();

  const { columnTitles, renderRow, NewIP } = useTableSettings({
    refetch,
  });

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorMessage error={error} />;

  if (ipWhitelist) {
    const NewIPBtn = withRoleAccess(ModalOpenBtn, ['admin']);

    return (
      <>
        {isFetching && <Loading />}

        <TableProvider<IIPWhitelistTableColumns> columnTitles={columnTitles} {...filter}>
          <TableActions>
            <TableActionsItem>
              <NewIPBtn text='New' modalContent={<NewIP />} />
            </TableActionsItem>
          </TableActions>

          <TableContainer>
            <Table>
              <THead />
              <TBody items={ipWhitelist.data} renderItem={renderRow} />
            </Table>
          </TableContainer>
          <div className='pagination-container'>
            <Pagination data={ipWhitelist.meta} />
            <PaginationRows />
          </div>
        </TableProvider>
      </>
    );
  }

  return null;
};

export default SettingsIPWhitelistWidget;
